export default "__VITE_ASSET__f680620c__"